import { render, staticRenderFns } from "./CheckboxBase.vue?vue&type=template&id=51f10f79&"
import script from "./CheckboxBase.vue?vue&type=script&lang=js&"
export * from "./CheckboxBase.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports